import * as React from 'react';
import { Service, IServiceProps } from './Service';

type TStaticProps = 'title' | 'subTitle' | 'bgColor' | 'icon' | 'description' | 'dataName';

export type IServiceDynamicProps = Omit<IServiceProps, TStaticProps>;
export type IServiceStaticProps = Pick<IServiceProps, TStaticProps>;

/**
 *
 * @description HOC для создание услуги размещения (топ, премиум и т.д.)
 * @param staticProps - статические данные услуги
 * @param dynamicProps - динамические данные услуги
 */
export const createService = (staticProps: IServiceStaticProps): React.FunctionComponent<IServiceDynamicProps> =>
  function ServiceWrapper(dynamicProps) {
    return <Service {...dynamicProps} {...staticProps} />;
  };
